import { useEffect, useRef } from 'react';

import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import { categoricalPallete } from '../themes/colors';

export type TBarChartOptions = {
  colors?: string[];
  yAxisTitle?: string;
  tooltipFormatter?: (this: any) => string;
  xAxisFormatter?: (ctx: any) => string;
  onClick?: (e: any) => void;
  unselect?: boolean;
  height?: string | number;
  type?: 'bar' | 'column';
  options?: Highcharts.Options;
};

export const BarChart = ({
  data,
  chartOptions,
}: {
  data?: { name: string; data: number[] }[];
  chartOptions: TBarChartOptions;
}) => {
  const chartRef = useRef<HighchartsReact.RefObject>(null);

  const options: Highcharts.Options = {
    chart: {
      type: chartOptions.type ?? 'column',
      style: {
        fontFamily: 'Inter',
      },
      backgroundColor: 'white',
      height: chartOptions.height,
    },
    plotOptions: {
      column: {
        pointPadding: 0,
        borderWidth: 0,
        borderRadius: 0,
        allowPointSelect: true,
        events: {
          click: chartOptions.onClick,
        },
      },
    },
    xAxis: {
      labels: {
        formatter: chartOptions.xAxisFormatter,
        rotation: 45,
        step: 1,
      },
    },
    tooltip: {
      formatter: chartOptions.tooltipFormatter,
    },
    yAxis: {
      min: 0,
      title: {
        text: chartOptions.yAxisTitle,
      },
    },
    colors: chartOptions.colors ?? categoricalPallete,
    legend: {
      enabled: false,
    },
    series: data?.map((series) => ({
      ...series,
      type: 'column',
    })),
    credits: {
      enabled: false,
    },
    ...chartOptions.options,
  };

  useEffect(() => {
    if (chartOptions.unselect) {
      for (const point of chartRef.current?.chart.getSelectedPoints() ?? []) {
        point.select(false);
      }
    }
  }, [chartOptions.unselect]);

  return (
    <HighchartsReact ref={chartRef} highcharts={Highcharts} options={options} />
  );
};
